module.exports = __webpack_public_path__ + "img/upload.92daee8f.png";